import {Badge, Button, Dropdown} from 'antd';
import {RiMenu4Line} from 'react-icons/ri';
import {FiUser} from 'react-icons/fi';
import {FaRegBell, FaRegUser} from "react-icons/fa";
import Cookies from 'js-cookie';

import {useDispatch, useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import {MdQuestionMark} from "react-icons/md";
import logo from '../../images/logo2.svg';
import {useJwt} from "react-jwt";
import {handleSidebarStatus} from '../store/SettingRedux/SettingRedux';
import ChangePass from '../pages/login/ChangePass';
import Logout from '../pages/login/LogoutModal';
import {useEffect, useState} from "react";
import Auth from "../http_request/Model/auth/Auth";

const HeaderBox = () => {
    const {decodedToken} = useJwt(Cookies.get('token'));
    const dispatch = useDispatch();
    const sidebarStatus = useSelector((state) => state.SettingRedux.sidebarStatus);
    const againHandlerWarningCount = useSelector((state) => state.TableRedux.againHandlerWarningCount);
    const [count, setCount] = useState()
    const items = [
        {
            label: <div className='py-2 px-4 flex items-center gap-2'><FiUser
                size={18}/>{decodedToken && decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name']}
            </div>,
            key: '0',
        },
        {
            type: 'divider',
        },
        {
            label: <ChangePass/>,
            key: '1',
        },
        {
            type: 'divider',
        },
        {
            label: <Logout/>,
            key: '3',
        },
    ];


    useEffect(() => {

        const interval = setInterval(() => {
            getCount()
        }, 20000);


        const getCount = () => {
            Auth.request({
                beforeSend: () => {
                }, success: (res) => {
                    setCount(res)

                }, error: (error) => {

                }, final: () => {

                },
            }).warningCount();
        }
        getCount()

        return () => clearInterval(interval);
    }, [againHandlerWarningCount])


    return (
        <div
            className='z-10 h-14 w-full flex justify-between items-center fixed top-0 right-0 shadow-md py-4 px-8 bg-white'>
            <div className='flex items-center gap-3'>
                <img className='w-24' src={logo} alt=""/>
                <Button type='link' className='text-black' onClick={() => {
                    dispatch(handleSidebarStatus(sidebarStatus === 3 ? 1 : sidebarStatus + 1))
                }}><RiMenu4Line size={23}/></Button>
            </div>
            <div className='flex justify-between items-center gap-3'>


                <Badge count={count} mode='right'>
                    <Link to='/Notification'><FaRegBell size={23}/></Link>
                </Badge>


                <Link to='/Faq'><MdQuestionMark size={23}/></Link>
                <Dropdown menu={{items}} trigger={['click']}>

                    <div className='cursor-pointer'><FaRegUser size={23}/></div>
                </Dropdown>
            </div>

        </div>
    );
};

export default HeaderBox;